.root {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  width: 100%;
}

.instructions {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
}

.readout {
  font-size: var(--tuna-typography-body2-fontSize);
  font-variant-numeric: tabular-nums;
}

.controls,
.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--tuna-spacing-2);
}
